import type { User } from '@openclassrooms/sdk-web';

import featureFlagSwitcher from './featureFlagSwitcher';

/* eslint-disable @typescript-eslint/no-unused-vars */
export default function createFeatureDecisions(user: User | null = null) {
  return {
    isNotificationPreferencesEnabled() {
      return featureFlagSwitcher('isNotificationPreferencesEnabled');
    },
    isNewCoursesScreenEnabled() {
      return featureFlagSwitcher('newCourseDashboard');
    },
    isTalentSyllabusEnabled() {
      return true;
    },
    isHeaderContactPanelEnabled() {
      return true;
    },
    isOCRCVEnabled() {
      return true;
    },
    isTalentShortlistEnabled() {
      return true;
    },
    isDiplomaFilterEnabled() {
      return featureFlagSwitcher('isDiplomaFilterEnabled');
    },
  };
}
